import { atom } from "recoil"

export const AtomCurrentProfileName = atom({
    key:'ATOMCURPROFILENAME',
    default:''
})
  